import { render, staticRenderFns } from "./v-select-basic.vue?vue&type=template&id=c037fa38&scoped=true&"
import script from "./v-select-basic.vue?vue&type=script&lang=js&"
export * from "./v-select-basic.vue?vue&type=script&lang=js&"
import style0 from "./v-select-basic.vue?vue&type=style&index=0&id=c037fa38&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c037fa38",
  null
  
)

export default component.exports